module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_map_3-fdb36c1546af9b63cccafc4bb9ec50b0.svg";